import React, {PureComponent} from 'react';
import styled from 'styled-components';
import {HexColorPicker} from 'react-colorful';
import {v4 as uuid} from 'uuid';

import Button from './Button';
import Popover from './Popover';

class ColorPicker extends PureComponent {
  id = uuid();
  state = {
    open: false
  };

  togglePicker = () => {
    this.setState({open: !this.state.open});
  }

  closePicker = () => {
    this.setState({open: false});
  }

  render() {
    return(
      <>
        <StyledButton blank id={this.id} onClick={this.togglePicker}><Square color={this.props.color} /></StyledButton>
        <Popover open={this.state.open} relativeTo={this.id} onClose={this.closePicker}>
          <HexColorPicker {...this.props} />
        </Popover>
      </>
    )
  }
}

const Square = styled.span`
  display: block;
  width: calc(2.25rem + 2px);
  height: 100%;
  background-color: ${props => props.color};
  border-radius: 0 .25rem .25rem 0;
`;

const StyledButton = styled(Button)`
  height: 100%;
`

export default ColorPicker;